/* Freedom Band cart companion picker - unpublished theme.
   Persistent delegated handlers survive Shopify AJAX section replacements. */
(function () {
  'use strict';
  if (window.fbcCartMoodPickerBound) return;
  window.fbcCartMoodPickerBound = true;

  function panelFor(node) {
    return node && node.closest ? node.closest('#fbc-mood-offer') : null;
  }
  function initPanel(panel) {
    if (!panel || panel.dataset.fbcMoodInitialized === '1') return;
    panel.dataset.fbcMoodInitialized = '1';
    try {
      if (sessionStorage.getItem('fbc-mood-hide-' + panel.dataset.source + '-' + panel.dataset.handle) === '1') {
        panel.hidden = true;
      }
    } catch (error) {}
  }
  function init() {
    document.querySelectorAll('#fbc-mood-offer').forEach(initPanel);
  }
  function getMatches(panel, group) {
    var pool = panel.querySelector('[data-mood-pool]');
    if (!pool) return [];
    return Array.from(pool.options).filter(function (option) {
      return option.dataset.group === group;
    });
  }
  function setVariant(panel, button, variant) {
    if (!variant) return;
    panel.dataset.fbcMoodVariant = variant.value;
    var image = button.querySelector('img');
    if (image && variant.dataset.image && image.getAttribute('src') !== variant.dataset.image) {
      image.src = variant.dataset.image;
    }
    var price = variant.dataset.price || '';
    var chosen = panel.querySelector('[data-mood-chosen]');
    if (chosen) chosen.textContent = (button.dataset.label || 'Selected') + (price ? ' · ' + price : '');
    var add = panel.querySelector('[data-mood-add]');
    if (add) {
      add.disabled = false;
      add.textContent = '+ Add' + (price ? ' ' + price : '');
    }
    var status = panel.querySelector('[data-mood-status]');
    if (status) status.hidden = true;
  }
  function choose(panel, button) {
    var matches = getMatches(panel, button.dataset.group);
    if (!matches.length) return;
    panel.querySelectorAll('[data-mood-pick]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });
    var row = panel.querySelector('.fbc-mood-offer__row');
    if (row) row.classList.add('fbc-mood-has-selection');
    var pack = panel.querySelector('[data-mood-pack]');
    if (!pack) return;
    pack.replaceChildren();
    if (matches.length > 1) {
      matches.forEach(function (variant) {
        var item = document.createElement('option');
        item.value = variant.value;
        item.textContent = variant.textContent.trim() + ' — ' + (variant.dataset.price || '');
        pack.appendChild(item);
      });
      pack.hidden = false;
    } else {
      pack.hidden = true;
    }
    setVariant(panel, button, matches[0]);
  }

  document.addEventListener('click', async function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-mood-pick],[data-mood-add],[data-mood-skip]');
    if (!button) return;
    var panel = panelFor(button);
    if (!panel) return;
    initPanel(panel);
    if (panel.hidden) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.hasAttribute('data-mood-pick')) {
      choose(panel, button);
      return;
    }
    if (button.hasAttribute('data-mood-skip')) {
      panel.hidden = true;
      try {
        sessionStorage.setItem('fbc-mood-hide-' + panel.dataset.source + '-' + panel.dataset.handle, '1');
      } catch (error) {}
      return;
    }
    if (button.disabled || !panel.dataset.fbcMoodVariant) return;
    var status = panel.querySelector('[data-mood-status]');
    var previous = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.hidden = true;
    try {
      var response = await fetch(panel.dataset.addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({
          id: Number(panel.dataset.fbcMoodVariant),
          quantity: 1,
          properties: {'_FBC cart upsell': 'Upgrade Your Mood'}
        })
      });
      if (!response.ok) throw new Error('Unable to add this option. Please try again.');
      document.querySelectorAll('#fbc-mood-offer,#fbc-underpatch-offer').forEach(function (offer) {
        offer.hidden = true;
      });
      window.location.reload();
    } catch (error) {
      if (status) {
        status.textContent = error.message || 'Please try again.';
        status.hidden = false;
      }
      button.disabled = false;
      button.textContent = previous;
    }
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var pack = target.closest('[data-mood-pack]');
    if (!pack) return;
    var panel = panelFor(pack);
    if (!panel || panel.hidden) return;
    var button = panel.querySelector('[data-mood-pick][aria-pressed="true"]');
    var pool = panel.querySelector('[data-mood-pool]');
    if (!button || !pool) return;
    var variant = Array.from(pool.options).find(function (option) {
      return option.value === pack.value;
    });
    if (variant) setVariant(panel, button, variant);
  }, true);

  document.addEventListener('cart:updated', function () {
    init();
    var panel = document.getElementById('fbc-mood-offer');
    if (!panel || panel.hidden) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', {credentials: 'same-origin'})
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var sourcePresent = cart.items.some(function (item) {
          return String(item.product_id) === panel.dataset.source;
        });
        var companionPresent = cart.items.some(function (item) {
          return String(item.product_id) === panel.dataset.companion;
        });
        var upsellAlreadyUsed = cart.items.some(function (item) {
          return item.properties && item.properties['_FBC cart upsell'];
        });
        if (!sourcePresent || companionPresent || upsellAlreadyUsed) panel.hidden = true;
      })
      .catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();